/**
 * رجیستری تم‌ها
 * برای افزودن تم جدید:
 *   1. یه فولدر در src/themes/<name> بساز
 *   2. اینجا register کن
 */
const themeRegistry = {
  default: () => import('./default/index.js'),
  modern:  () => import('./modern/index.js'),
  neon:    () => import('./neon/index.js'),
  persia:  () => import('./persia/index.js'),
  sakura:    () => import('./sakura/index.js'),
  brutalist: () => import('./brutalist/index.js'),
};

/**
 * لود lazy تم
 * @param {string} themeName - مقدار form_shop_theme از بکند
 * @returns {Promise<ThemeModule>}
 */
export async function loadTheme(themeName) {
  const loader = themeRegistry[themeName] ?? themeRegistry['default'];
  const module = await loader();
  return module.default ?? module;
}

export default themeRegistry;
